module.exports = __webpack_public_path__ + "img/623cde7.jpg";